module.exports = __webpack_public_path__ + "img/lady.20e4bd9b.png";